import {
  Button,
  Card,
  Illustration,
  Modal,
  Section,
  SectionSubtitle,
  SectionTitle,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { TbArrowRight } from 'react-icons/tb';
import type { UpdateLitterModalProps } from './types';

export * from './types';

export const UpdateLitterModal: FC<UpdateLitterModalProps> = (props) => {
  const { modal, onConfirm } = props;

  const { translate } = useTranslation();
  const { translate: translateRessource } = useTranslation({
    keyPrefix: 'common.modals.updateLitter',
  });

  return (
    <Modal {...modal}>
      <Card size="small" isModal>
        <Section centerChildren>
          <SectionTitle>{translateRessource('title')}</SectionTitle>
          <Illustration type="litter" />
          <SectionSubtitle>{translateRessource('text')}</SectionSubtitle>
        </Section>

        <Section centerChildren>
          <Button
            onClick={onConfirm}
            color="blue"
            size="medium"
            iconRight={<TbArrowRight />}
            shrink
          >
            {translate('common.buttons.myLitters')}
          </Button>
        </Section>
      </Card>
    </Modal>
  );
};
